<template>
  <div class="custom-grid">
    <el-form-item label :rules="uploadRules">
      <div class="grid">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          list-type="picture-card"
          :on-success="handleFileSuccess"
          :before-upload="beforeFileUpload"
          :headers="headers"
          :disabled="imgLoading || disabled"
          :multiple="isMultiple"
          :limit="maxCount"
          :file-list="fileList"
          :on-preview="handlePreview"
          :on-exceed="handleExceed"
          :on-remove="handleRemove"
        >
          <div class="avatar-uploader-icon" v-if="!disabled">
            <span class="icon-wrap">
              <i class="el-icon-loading" v-show="imgLoading" />
              <i class="el-icon-plus" v-show="!imgLoading" />
            </span>
          </div>
          <div class="avatar-uploader-icon" v-else>
            <i class="el-icon-remove-outline" />
          </div>
          <div
            slot="file"
            slot-scope="{ file }"
            style="display:flex;align-items:center;justify-content:center;width:100%;height:100%;"
          >
            <!-- {{ JSON.stringify(file) }} -->
            <img
              v-if="!file.name.includes('.pdf')"
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <div v-if="file.name.includes('.pdf')">
              <img
                style="width:76px;height:90px;"
                src="@/assets/icon/pdf.png"
                alt=""
              />
            </div>
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>

              <span
                v-if="!disabled"
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
      </div>
      <el-image-viewer
        v-show="dialogVisible && dialogType === 'image'"
        :initial-index="dialogIndex"
        :on-close="
          () => {
            dialogVisible = false;
          }
        "
        :url-list="propImages.length ? propImages : [dialogImageUrl]"
        style="z-index: 9999"
      />
      <el-dialog
        title="文件预览"
        :visible.sync="webviewDialogVisible"
        width="60%"
        append-to-body
        :close-on-click-modal="true"
      >
        <iframe
          v-if="webviewDialogVisible"
          :src="webviewUrl"
          frameborder="0"
          style="width: 100%; height: 600px;"
        ></iframe>
      </el-dialog>
    </el-form-item>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
  name: "PdfUpload",
  components: {
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer")
  },
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: [Boolean, Number],
      default: true
    },
    maxCount: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      uploadUrl: `${this.BASE_API_URL}ntocc-tps-api/fileUpload`,
      dialogImageUrl: "",
      dialogVisible: false,
      dialogIndex: 0,
      dialogType: "image",
      webviewDialogVisible: false,
      webviewUrl: "",
      imgLoading: false,
      headers: {
        Authorization: "Bearer ",
        deviceId: "0000000000"
      },
      fileList: []
    };
  },
  computed: {
    isMultiple() {
      return Number(this.maxCount) > 1;
    },
    propImages() {
      if (this.isMultiple) {
        if (Array.isArray(this.imgList)) return this.imgList;
        if (typeof this.imgList === "string" && this.imgList)
          return [this.imgList];
        return [];
      } else {
        return this.imgList && this.imgList.length > 0 ? [this.imgList[0]] : [];
      }
    },
    uploadRules() {
      if (!this.required) return [];
      if (this.isMultiple) {
        return [
          {
            type: "array",
            min: 1,
            message: `请上传文件`,
            trigger: "change"
          }
        ];
      } else {
        return [{ required: true, message: `请上传文件`, trigger: "change" }];
      }
    }
  },
  watch: {
    imgList: {
      handler(newVal) {
        console.log("imgList========", newVal);
        if (!newVal || newVal.length === 0) {
          this.fileList = [];
          return;
        }
        console.log("===========处理数据======", newVal);
        if (Array.isArray(newVal)) {
          this.fileList = newVal.map((item, index) => {
            if (typeof item === "string") {
              const isPdf = item.toLowerCase().endsWith(".pdf");
              return {
                uid: Date.now() + index,
                name: isPdf ? `file-${index}.pdf` : `image-${index}`,
                status: "success",
                url: item,
                response: { data: item },
                type: isPdf ? "application/pdf" : "image"
              };
            }
            return item;
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传${this.maxCount}个文件`);
    },
    beforeFileUpload(file) {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/bmp" ||
        file.type === "image/png" ||
        file.type === "image/gif";
      const isPdf = file.type === "application/pdf";
      const isAllowed = isImage || isPdf;
      const isLtnM = file.size / 1024 / 1024 < 50;
      const isLtnM2 = file.size >= 1024;

      if (!isAllowed) {
        this.$message.error("上传文件只能是 JPG,BMP,PNG,GIF 或 PDF 格式!");
        return false;
      }
      if (!isLtnM2) {
        this.$message.error("上传文件大小不能小于 1K!");
        return false;
      }
      if (!isLtnM) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return false;
      }
      if (isAllowed && isLtnM && isLtnM2) {
        if (this.isMultiple) {
          const count = Array.isArray(this.imgList) ? this.imgList.length : 0;
          if (count >= this.maxCount) {
            this.$message.warning(`最多上传${this.maxCount}个文件`);
            return false;
          }
        }
        this.imgLoading = true;
        this.headers.Authorization = "Bearer " + getToken();
      }
      return true;
    },
    async handleFileSuccess(res, file) {
      if (res.status == 500) {
        this.$message.error(res.msg);
        this.imgLoading = false;
        return;
      } else {
        await this.$emit("handleFileSuccess", res.data);
        let newImgList = [];
        if (this.isMultiple) {
          newImgList = Array.isArray(this.imgList) ? [...this.imgList] : [];
          newImgList.push(res.data);
        } else {
          newImgList = [res.data];
        }
        this.imgLoading = false;
        this.$emit("update:imgList", newImgList);

        const isPdf = res.data.toLowerCase().endsWith(".pdf");
        const fileItem = {
          uid: file.uid || Date.now(),
          name: isPdf
            ? `file-${this.fileList.length}.pdf`
            : `image-${this.fileList.length}`,
          status: "success",
          url: res.data,
          response: { data: res.data },
          type: isPdf ? "application/pdf" : "image"
        };

        if (this.isMultiple) {
          this.fileList.push(fileItem);
        } else {
          this.fileList = [fileItem];
        }
      }
    },
    handlePreview(file) {
      console.log("预览===", file, this.fileList);
      const isPdf =
        file.url.toLowerCase().endsWith(".pdf") ||
        file.type === "application/pdf";

      if (isPdf) {
        window.open(file.url, "_blank");
      } else {
        this.dialogIndex = file.uid || 0;
        this.dialogImageUrl = file.url;
        this.dialogType = "image";
        this.dialogVisible = true;
      }
    },
    handlePictureCardPreview(file) {
      const url =
        file.response && file.response.data
          ? file.response.data.trim()
          : file.url;
      const isPdf =
        url.toLowerCase().endsWith(".pdf") || file.type === "application/pdf";

      if (isPdf) {
        this.webviewUrl = url;
        this.webviewDialogVisible = true;
      } else {
        this.dialogImageUrl = url;
        this.dialogType = "image";
        this.dialogVisible = true;
      }
    },
    handleRemove(file) {
      console.log("删除=====", file, "2222222222222", this.fileList);
      const fileIndex = this.fileList.findIndex(f => f.uid === file.uid);
      console.log("删除Index===", fileIndex);
      if (fileIndex > -1) {
        this.fileList.splice(fileIndex, 1);
      }

      let newImgList = [];
      if (this.isMultiple) {
        newImgList = Array.isArray(this.imgList) ? [...this.imgList] : [];
        const index = newImgList.findIndex(
          img =>
            img === file.url ||
            (typeof img === "object" && img.url === file.url)
        );
        if (index > -1) {
          newImgList.splice(index, 1);
        }
      } else {
        newImgList = [];
      }
      this.$emit("update:imgList", newImgList);
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-grid {
  display: inline-block;
  font-size: 14px;
  color: #8c939d;
  .grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  .avatar-uploader {
    position: relative;
    cursor: pointer;
    height: 150px;
    border-radius: 10px;
    overflow: hidden;
    .avatar-uploader-icon {
      font-size: 30px;
      color: #8c939d;
      border-radius: 10px;
      width: 150px;
      height: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #c0ccda;
      &:hover {
        border-color: #409eff;
      }
    }
    .avatar {
      width: 150px;
      height: 150px;
      display: block;
    }
    .el-upload-list__item-actions {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      text-align: center;
      color: #fff;
      opacity: 0;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      &:hover {
        opacity: 1;
      }
      .el-upload-list__item-icon {
        cursor: pointer;
        margin: 0 10px;
      }
    }
    .el-upload-list__item {
      transition: none !important;
    }
  }
}
.color-red {
  color: #f44336;
  line-height: 30px;
}
</style>
